// extracted by mini-css-extract-plugin
module.exports = {"sodicBannerWrapper":"style_sodicBannerWrapper__bOLvm","sodicBannerInner":"style_sodicBannerInner__wyi80","sodicBannerStory":"style_sodicBannerStory__wfSaX"};